export const KZ_LANG_CODE = "kz"
export const TRANSLATIONS_KZ = {
    welcome:"Welcome to the tutorial KZ" ,
    backToMain:"Сайтқа оралу",
    backToShop: "Дүкенге оралу",
    paymentMethod:{
        title:"Төлем әдістері",
        byCard:{
            title:"Онлайн карта арқылы",
            content:"Несие бойынша ай сайынғы төлемді Қазақстан Республикасындағы кез келген банктің картасымен төлеңіз",
            payBtn:{
                label:"жалғастыру"
            }
        },
        byKassa24:{
            title:"Kassa24 терминалында",
            content:"1. Kassa24 терминалына өтіңіз\n" +
                "2. AIRBA Pay қызметін іздеңіз\n" +
                "3. Іздеу нәтижелерінде AIRBA Pay басыңыз\n" +
                "4. Несие алуға өтініш берген ЖСН-ді енгізіңіз\n" +
                "5. Несие туралы ақпаратты тексеріңіз\n" +
                "6. Ай сайынғы төлемді төлеу үшін қажетті соманы енгізіп, «Төлеу» басыңыз.\n" +
                "\n" +
                "!Kassa24 терминалы өзгеріс бермейді.",
        },
        byYurta:{
            title:"«Юрта» терминалында",
            content:"1. Yurta компаниясының кез келген Ю-Станция терминалына барыңы\n" +
                "2. Ю-Финансы бөлімін таңдаңыз2.\n" +
                "3. МКҰ және МҚҰ микрокредиттері кіші бөлімін таңдаңыз\n" +
                "4. Тізімнен AIRBA Pay таңдаңыз\n" +
                "5. Несие алуға өтініш берген ЖСН-ді енгізіңіз\n" +
                "6. Несие туралы ақпаратты тексеріңі\n" +
                "7. Ай сайынғы төлемді төлеу үшін қажетті соманы енгізіп, «Төлеу» басыңыз.\n" +
                "\n" +
                "!Ю-Станция терминалы өзгеріс бермейді.",
        }
    },
    paymentForm: {
        title : "Несие төлеу",
        iin:{
            label:"Сіздің ЖСН",
            placeholder:"ЖСН енгізіңіз"
        },
        smsCode: {
            label: "Телефон нөміріңізге жіберілген SMS кодты енгізіңіз",
            placeholder: "SMS-код",
        },
        sendBtn: {
            label:"Жіберу",
        },
    },
    loanInfo: {
        title : "Несие төлеу",
        iin: "ЖСН",
        monthlyPayment: {
            label:"{{date}} дейінгі ай сайынғы төлем:",
        },
        kzt: {
            label:"теңге",
        },
        payBtn: {
            label:"Төлеу",
            hint:"«Төлеу» түймесін басу арқылы сіз төлем бетіне қайта бағытталасыз",
        },
        tryBtn: {
            label:"Қайталап көріңіз",
        },
    },
    paymentResult: {
        title : "Несие төлеу",
        successMessage:"Құттықтаймыз! Төлем төленді.",
        errorMessage:"Бірдеңе дұрыс болмады :(",
        tryBtn: {
            label:"Қайталап көріңіз",
        },
    },
    errors: {
        clientNotFound: "Клиент табылмады",
        smsCodeWrong: "Жарамсыз SMS коды",
        smsCodeSend: "SMS кодын жіберу қатесі",
        smsCodeCheck: "SMS кодын тексеру кезінде қате",
        getLoanInfo:"Несие туралы ақпаратты алу қатесі",
        getPaymentLink: "Төлем сілтемесін алу қатесі",
    },
};